import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Transformation() {
  const before = ['Te levantás cansado.', 'Dependés de café para arrancar.', 'Sentís bajones de energía.', 'Dormís pero no descansás.', 'Vivís apagando incendios.', 'Tu cuerpo acompaña cada vez menos tu ambición.'];
  const after = ['Rutina clara de energía diaria.', 'Mejor estructura de sueño.', 'Menos caos con comidas y suplementos.', 'Más foco durante el día.', 'Hábitos simples, medibles y sostenibles.', 'Sensación de mayor control sobre tu rendimiento.'];
  return <section className="py-24 px-6 bg-brand-bg" data-id="element-737">
      <div className="max-w-[1000px] mx-auto" data-id="element-738">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-739">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-740">
            La Transformación del Sistema
          </h2>
          <p className="text-xl text-brand-muted" data-id="element-741">
            Mejorá tus indicadores diarios de energía, descanso, foco y
            rendimiento con un sistema simple de 90 días.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-742">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-brand-red/5 border border-brand-red/20 rounded-[20px] overflow-hidden" data-id="element-743">
            <div className="bg-brand-red/10 p-6 border-b border-brand-red/20" data-id="element-744">
              <h3 className="text-xl font-bold text-white flex items-center gap-2" data-id="element-745">
                <X className="w-6 h-6 text-brand-red" data-id="element-746" /> ANTES DE BIO-X 90
              </h3>
            </div>
            <div className="p-6 space-y-6" data-id="element-747">
              {before.map((item, idx) => <div key={idx} className="flex items-start gap-3 opacity-80" data-id="element-748">
                  <X className="w-5 h-5 text-brand-red shrink-0 mt-0.5" data-id="element-749" />
                  <p className="text-white text-base leading-relaxed" data-id="element-750">{item}</p>
                </div>)}
            </div>
          </motion.div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-brand-cyan/5 border border-brand-cyan rounded-[20px] overflow-hidden shadow-[0_0_30px_rgba(0,212,170,0.1)]" data-id="element-751">
            <div className="bg-brand-cyan/10 p-6 border-b border-brand-cyan/20" data-id="element-752">
              <h3 className="text-xl font-bold text-white flex items-center gap-2" data-id="element-753">
                <Check className="w-6 h-6 text-brand-cyan" data-id="element-754" /> DESPUÉS DE APLICAR
                EL SISTEMA
              </h3>
            </div>
            <div className="p-6 space-y-6" data-id="element-755">
              {after.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-756">
                  <Check className="w-5 h-5 text-brand-cyan shrink-0 mt-0.5" data-id="element-757" />
                  <p className="text-white text-base font-medium leading-relaxed" data-id="element-758">
                    {item}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}